import { render, staticRenderFns } from "./PublisherFormWizard.vue?vue&type=template&id=69d18d56&scoped=true&"
import script from "./PublisherFormWizard.vue?vue&type=script&lang=js&"
export * from "./PublisherFormWizard.vue?vue&type=script&lang=js&"
import style0 from "./PublisherFormWizard.vue?vue&type=style&index=0&id=69d18d56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d18d56",
  null
  
)

export default component.exports